import React, { Fragment } from "react";
import { connect } from "react-redux";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import { addToCart, addToWishList } from "../../store/actions/action";
import ShopProduct from "../../components/ShopProduct";
import api from "../../api";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { ProductItem } from "../../store/actions/action"; 

// Props Interface
interface ShopPageProps {
  addToCart: (product: ProductItem, qty?: number) => void;
  addToWishList: (product: ProductItem) => void;
}

const ShopPage: React.FC<ShopPageProps> = ({ addToCart, addToWishList }) => {
  const productsArray: ProductItem[] = api();

  const addToCartProduct = (product: ProductItem, qty = 1): void => {
    addToCart(product, qty);
  };

  const addToWishListProduct = (product: ProductItem): void => {
    addToWishList(product);
  };

  return (
    <Fragment>
      {/* ✅ Navbar */}
      <Navbar hclass="wpo-header-style-1" />

      {/* ✅ Page Title */}
      <PageTitle pageTitle="Shop" pagesub="Shop" />

      {/* ✅ Shop Section */}
      <section className="wpo-shop-page section-padding">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <ShopProduct
                addToCartProduct={addToCartProduct}
                addToWishListProduct={addToWishListProduct}
                products={productsArray}
              />
            </div>
          </div>
        </div>
      </section>

      {/* ✅ Footer + Scrollbar */}
      <Footer footerClass="wpo-site-footer-s1" />
      <Scrollbar />
    </Fragment>
  );
};

export default connect(null, { addToCart, addToWishList })(ShopPage);
